import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import HelpDrawer from '@helsenorge/designsystem-react/components/HelpDrawer';
import Loader from '@helsenorge/designsystem-react/components/Loader';
import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';
import PortableText from '@helsenorge/core-cms/richtext';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { HNeventHjelpeskuffClosed } from '../events';
import { closeHjelpeskuff, selectHjelpeskuffState } from '../store/hjelpeskuff';
import useHjelpetekstEvent from '../store/hooks/useHjelpetekstEvent';
/**
 * Hjelpeskuff som viser hjelpetekst for en tjeneste.
 */
const Hjelpeskuff = () => {
    const dispatch = useAppDispatch();
    const { isOpen, hjelpeskuffTittel: overskrift, hjelpeskuffTekst: hjelpetekst, status, error } = useAppSelector(selectHjelpeskuffState);
    const handleClose = () => {
        dispatch(closeHjelpeskuff());
        HNeventHjelpeskuffClosed();
    };
    useHjelpetekstEvent();
    return (_jsxs(HelpDrawer, { isOpen: isOpen, title: overskrift, onRequestClose: handleClose, children: [status === 'loading' && _jsx(Loader, {}), status === 'failed' && _jsx(NotificationPanel, { variant: "error", children: error }), _jsx(PortableText, { value: hjelpetekst })] }));
};
export default Hjelpeskuff;
